









































































import GuardileoCheckbox from "@/Drittlandtransferpruefung/GuardileoCheckbox.vue";
import Vorfallmanagement from "@/Vorfallmanagement/api/Vorfallmanagement";
import ListenCheckbox from "@/Vorfallmanagement/components/ListenCheckbox.vue";
import { Component, Prop, PropSync, Watch } from "vue-property-decorator";
import SubTabBaseVfmt from "../SubTab-Base-vfmt";

@Component({
  components: { GuardileoCheckbox, ListenCheckbox },
})
export default class extends SubTabBaseVfmt {
  @PropSync("beurteilung")
  internalBeurteilung!: Vorfallmanagement.RechtlicheBeurteilung;
  @Prop() leitlinie!: Vorfallmanagement.Leitlinie;

  private get locale() {
    return this.$i18n.locale.toUpperCase();
  }

  setChoice(bln: boolean) {
    const temp = { ...this.internalBeurteilung };
    if (bln === temp.IstBenachrichtigungErfoderlich) {
      temp.IstBenachrichtigungErfoderlich = null;
    } else {
      temp.IstBenachrichtigungErfoderlich = bln;
    }
    this.internalBeurteilung = temp;
  }
}
